import {DirectiveBinding} from 'vue/types/options';
import {VNode} from 'vue';

export const clickOutside = {
  bind(el: CustomElement, binding: DirectiveBinding, vnode: VNode) {
    el.clickOutsideEvent = function(event: Event): void {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el: CustomElement) {
    if (el.clickOutsideEvent) {
      document.removeEventListener('click', el.clickOutsideEvent);
    }
  },
};
